/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';

/* ++++++++++ --------------- app.filters : STYLES --------------- ++++++++++ */
export default {
    sitefilter: {
        display: 'flex',
        '& .singleselectdropdown': { 
            maxWidth: pxToEm(360), 
            width: '100%', 
            marginRight: pxToEm(16), 
            marginBottom: pxToEm(8) 
        },
        '& .button': { width: pxToEm(140),  marginBottom: pxToEm(8) },
        '& header': { width: '100%' },
        '& .headercontent': {
            display: 'flex',
            alignItems: 'center',
            flexFlow: 'wrap'
        }
    }
};
